import React from "react";
import { ncbInterpolColors } from "../../../modules/shared/utilities/colorConfig";

interface TimelineEvent {
  period: string;
  title: string;
  description: string;
}

interface TimelineSectionProps {
  events: TimelineEvent[];
}

const TimelineSection: React.FC<TimelineSectionProps> = ({ events }) => {
  return (
    <div className="p-8">
      <h2
        className={`text-2xl font-bold mb-8 ${ncbInterpolColors.text.primary}`}
      >
        Sejarah & Perkembangan
      </h2>
      <div className="relative">
        {/* Timeline line */}
        <div
          className={`absolute left-4 top-0 bottom-0 w-0.5 bg-primary`}
        ></div>

        {/* Timeline events */}
        <div className="space-y-8">
          {events.map((event, index) => (
            <div key={index} className="relative flex gap-x-6">
              {/* Timeline dot */}
              <div
                className={`relative z-10 flex items-center justify-center w-8 h-8 bg-primary ${ncbInterpolColors.common.roundedFull} flex-shrink-0`}
              >
                <span
                  className={`w-3 h-3 ${ncbInterpolColors.background.card} ${ncbInterpolColors.common.roundedFull}`}
                ></span>
              </div>

              {/* Event content */}
              <div
                className={`flex-grow pb-8 ${ncbInterpolColors.background.section} ${ncbInterpolColors.common.roundedSmall} p-6`}
              >
                <div
                  className={`text-sm font-medium ${ncbInterpolColors.accent.bullet} mb-1`}
                >
                  {event.period}
                </div>
                <h3
                  className={`text-lg font-bold ${ncbInterpolColors.text.primary} mb-2`}
                >
                  {event.title}
                </h3>
                <p
                  className={`${ncbInterpolColors.text.secondary} leading-relaxed`}
                >
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimelineSection;
